import type { ConversationDifficulty as PrismaConversationDifficulty } from "@prisma/client";

/**
 * The difficulty as it travels over the wire and appears in the UI. The database
 * stores the uppercase Prisma enum; the two maps below are the only translation,
 * and `satisfies` makes each exhaustive in its own direction.
 */
export const CONVERSATION_DIFFICULTIES = ["easy", "standard", "stretch"] as const;

export type ConversationDifficulty = (typeof CONVERSATION_DIFFICULTIES)[number];

export const DIFFICULTY_TO_PRISMA = {
  easy: "EASY",
  standard: "STANDARD",
  stretch: "STRETCH",
} as const satisfies Record<ConversationDifficulty, PrismaConversationDifficulty>;

export const DIFFICULTY_FROM_PRISMA = {
  EASY: "easy",
  STANDARD: "standard",
  STRETCH: "stretch",
} as const satisfies Record<PrismaConversationDifficulty, ConversationDifficulty>;

export type ConversationPersona = {
  name: string;
  setting: string;
  voiceStyle: string;
  openingLine: string;
  scenarioId: string;
  curriculumLevelHint?: string;
};

export type ConversationTranscriptRow = {
  role: "learner" | "persona";
  text: string;
  timestamp: string;
};

export type ConversationDebriefToReviewItem = {
  text: string;
  learnerText?: string;
  correction?: string;
  errorCategorySlug: string;
  unitSlug?: string;
  lessonId?: number;
  lessonHref?: string;
};

export type ConversationDebriefNewWordItem = {
  word: string;
  definition: string;
  wordId?: number;
};

export type ConversationDebrief = {
  usedWell: Array<{ text: string; example?: string }>;
  toReview: ConversationDebriefToReviewItem[];
  newWords: ConversationDebriefNewWordItem[];
  fluencyNote: string;
};

export type ScenarioCard = {
  scenarioId: string;
  title: string;
  setting: string;
  grammarFocus: string;
  persona: ConversationPersona;
};
